/**
 * 随访记录模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取随访记录列表
export const followUpList = (params) => {
  return req.get('/exam/record/list', params);
}

// 新增随访
export const followUpAdd = (params) => {
  return req.post('/exam/record', params);
}

// 批量新增
export const followUpListAdd = (params) => {
  return req.post('/exam/record/batch', params);
}

// 随访修改
export const followUpModified = (params) => {
  return req.put('/exam/record', params);
}

// 随访详情
export const followUpInfo = (examRecordId ) => {
  return req.get(`/exam/record/${examRecordId }`);
}

// 自动随访
export const followUpAuto = (params) => {
  return req.post('/exam/record/auto', params);
}

// 人工随访
export const followUpArtificial = (params) => {
  return req.post('/exam/record/artificial', params);
}

// 随访问题
export const followUpQuestion = (params) => {
  return req.get('/exam/record/questions/list', params);
}

// 随访各状态数量
export const statusNum = (params) => {
  return req.get('/exam/record/count', params);
}

// 重新推送
export const followUpAgain = (params) => {
  return req.post('/exam/record/push', params);
}